import { WifiOff } from "lucide-react";

const OfflineBanner = () => {
  return (
    <div className="offline-banner" data-testid="offline-banner">
      <div className="flex items-center justify-center gap-2">
        <WifiOff className="w-5 h-5" />
        <span>Mode hors ligne - Les données seront synchronisées automatiquement</span>
      </div>
    </div>
  );
};

export default OfflineBanner;
